import React, { Component } from "react";
import Editor from "./editor/Editor";
import MinNav from "./component/MinNav";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = { about: "" };
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}others/about`)
      .then(res => res.json())
      .then(data => {
        this.setState({ about: data.about });
      });
  }

  render() {
    return (
      <div className="a-container">
        <div className="a-comp-btn">
          <MinNav />
        </div>
        <Editor
          apiROOT={this.props.apiROOT}
          root={this.props.root}
          page="about"
          post={this.state.about}
        />
      </div>
    );
  }
}

export default About;
